import { compiler } from 'markdown-to-jsx'

  // Compiles markdown to JSX. `wrapper: null` yields the bare nodes rather than
  // a wrapping element, so callers can drop the result straight into a
  // ReactNode-typed field. Inline HTML (<br/>, <cite>) is parsed natively.
export const markdown = (s: string, options?: any) => (
  compiler(s, {
    wrapper: null,
    ...options
  })
)
